import api from '../api';

import type { QueryFunction } from '@tanstack/react-query';
import type { PaymentDetail } from 'domains/payment-titles';

export const getPaymentDetail: QueryFunction<PaymentDetail> = async ({
  queryKey: [titleId, isEudoraVdfPayment],
}) => {
  return (await api
    .get(`/reseller/payment-title/${titleId}/detail`, { params: { isEudoraVdfPayment } })
    .then((resp) => resp.data)) as PaymentDetail;
};
